<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <GrantsConstraintsPlansSlidDetailsForm
      v-if="!isLoading"
      :grantsConstraintsPlansSlidDetails="grantsConstraintsPlansSlidDetails"
      v-on:addOrUpdateGrantsConstraintsPlansSlidesDetails="
        addOrUpdateGrantsConstraintsPlansSlidesDetails
      "
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import { STATUS } from "@/utils/constants";
import GrantsConstraintsPlansSlidDetailsForm from "@/components/settings/settingsSalary/grantsConstraintsPlansSlidesDetails/GrantsConstraintsPlansSlidDetailsForm.vue";
import GrantsConstraintsPlansSlidDetails from "@/models/settings/settingsSalary/grantsConstraintsPlansSlidesDetails/GrantsConstraintsPlansSlidDetails";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    GrantsConstraintsPlansSlidDetailsForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      grantsConstraintsPlansSlidDetails:
        new GrantsConstraintsPlansSlidDetails(),
      grantsConstraintsPlansToken:
        this.$route.params.grantsConstraintsPlansToken,
    };
  },
  methods: {
    async addOrUpdateGrantsConstraintsPlansSlidesDetails() {
      this.isLoading = true;
      try {
        let response =
          await this.grantsConstraintsPlansSlidDetails.addOrUpdateGrantsConstraintsPlansSlidesDetails(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.grantsConstraintsPlansSlidDetails.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    if (
      this.grantsConstraintsPlansToken == "" ||
      this.grantsConstraintsPlansToken == undefined
    ) {
      this.$router.push({ name: "GrantsConstraintsPlans" }).catch(() => {});
    } else {
      this.grantsConstraintsPlansSlidDetails.grantsConstraintsPlansToken =
        this.grantsConstraintsPlansToken;
    }
  },
};
</script>
